export default __webpack_public_path__ + "static/media/galery_photo5@2x.9c2eb706.png";